import { defineStore } from "pinia";
import { actions } from "./actions";

export const useUserStore = defineStore("auth", {
  persist: {
    paths: [
      "status.loggedIn",
      "status.updatedProfile",
      "user",
      "permissionGroups",
      "password",
      "failedRequests",
      "error",
      "userPlans",
      "isAuthenticated"
    ]
  },
  state: (): AuthState => {
    const user = import.meta.client ? getJWTUser() : null;
    return {
      status: {
        loggedIn: !!user,
        updatedProfile: false,
        failedAttempt: false,
        activationPending: false,
        errorMessage: {
          error: false,
          message: ""
        }
      },
      user: user as User,
      permissionGroups: user?.groups || [],
      password: {
        resetRequested: false,
        resetConfirmed: false
      },
      failedRequests: 0,
      error: null,
      userPlans: [],
      isAuthenticated: !!user,
      setError: "",
      passwordResetClear: 0
    };
  },
  actions,
  getters: {
    getStatus: state => state.status,
    getCurrentUser: state => state.user,
    getUserPlans: state => {
      const plans = state.userPlans;
      if (Array.isArray(plans) && plans.length > 1) {
        return plans.filter(plan => plan.type !== "free");
      }
      return plans;
    },
    getUserPlanIds: state => state.userPlans.map((plan: Plan) => plan.id),
    isUserLoggedIn: state => state.status.loggedIn,
    isUserModerator: state =>
      state.permissionGroups.some((group: any) =>
        group.code.includes("moderator")
      )
  }
});

export const useNotificationStore = defineStore("notification", {
  actions: {
    error(payload: {
      variant: string;
      messageHead: string;
      messageBody: string;
    }) {
      if (process.env.NODE_ENV === 'production') {
        if (typeof window !== 'undefined' && window.$bugsnag) {
          const error = new Error(`${payload.messageHead}: ${payload.messageBody}`);
          window.$bugsnag.notify(error, {
            metaData: {
              variant: payload.variant,
              messageHead: payload.messageHead,
              messageBody: payload.messageBody
            }
          });
        }
      } else {
        console.log(`${payload.variant}- ${payload.messageHead}: ${payload.messageBody}`);
      }
    }
  }
});
